import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import MobileHeaderOnly from "components/headers/light.js";
import Footer from "salad/GrainFooter.js";

const HeaderWrap = styled.div`${tw`relative z-40`}`;

const PageBg = styled.div`
  ${tw`min-h-screen`}
  background-color: #fffbdc;
`;

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10 font-roboto`;

const Body = styled.div`
  ${tw`text-lg text-gray-800`}

  p {
    ${tw`mt-2 leading-loose`}
  }

  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }

  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }

  h3 {
    ${tw`text-xl font-bold mt-6`}
  }

  ul {
    ${tw`list-disc list-inside`}

    li {
      ${tw`ml-2 mb-3`}

      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

const BlogArticleLayout = ({ title, children }) => (
  <PageBg>
    <HeaderWrap>
      <MobileHeaderOnly
        logoSrc="https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/LOGO%20for%20website/Blue.svg"
        orderHref="https://order.grainmediterranean.com/"
      />
    </HeaderWrap>

    <AnimationRevealPage>
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{title}</Heading>
          </HeadingRow>
          <Body>{children}</Body>
        </ContentWithPaddingXl>
      </Container>
      <Footer />
    </AnimationRevealPage>
  </PageBg>
);

export default BlogArticleLayout;
